// extracted by mini-css-extract-plugin
export default {"navContainer":"q_cyy24dnaQMhZA3Bejp","nav":"VHjV6zwIzG_uCLvBUcg1","navConnectedAs":"Aviydna76YkXSbUEaX6k","navConnectedAsSpan":"HCAPAFKgdGnrqKsGz1mm"};